<template>
  <div class="ui-content">
    <div class="ui-seachBox">
      <el-row class="row-bg">
        <el-col :span="6">
          <p class="ui-seachBox-label">
            <span>姓名</span>
            <span class="ui-seachBox-Symbol">:</span>
          </p>
          <el-input class="ui-seachBox-input" clearable v-model="seach.userName" placeholder="请输入姓名" @keyup.enter.native="getList"></el-input>
        </el-col>
        <el-col :span="6">
          <p class="ui-seachBox-label">
            <span>电话</span>
            <span class="ui-seachBox-Symbol">:</span>
          </p>
          <el-input class="ui-seachBox-input" clearable v-model="seach.tbPhone" placeholder="请输入手机号" @keyup.enter.native="getList"></el-input>
        </el-col>
        <el-col :span="6">
          <p class="ui-seachBox-label">
            <span>自提点</span>
            <span class="ui-seachBox-Symbol">:</span>
          </p>
          <el-select class="ui-seachBox-input" clearable v-model="seach.tbShopId" placeholder="请选择自提点">
            <el-option v-for="item in shopList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-col>
        <el-button class="ui-seachBox-submit" type="primary" @click="getList" v-has="pathCode+':seach'">查 询</el-button>
        <el-button class="ui-seachBox-reset" @click="reset" v-has="pathCode+':reset'">重 置</el-button>
      </el-row>
    </div>
    <div class="ui-tableBox">
      <div class="ui-tableBox-bar">
        <p class="ui-tableBox-title">数据列表</p>
      </div>
      <div class="ui-tableList">
        <el-table v-loading="loading" :data="tableList" :max-height="tableHeight" :default-sort="{prop: 'tbSort', order: 'ascending'}" border style="width: 100%" :header-cell-style="{background: '#FAFAFA'}">
          <el-table-column align="center" type="index" width="68px" label="序号">
          </el-table-column>
          <el-table-column align="center" prop="createTime" label="测量时间">
          </el-table-column>
          <el-table-column align="center" prop="userName" label="姓名">
          </el-table-column>
          <el-table-column align="center" prop="phone" label="电话">
          </el-table-column>
          <el-table-column align="center" prop="goodsName" label="商品名称" show-overflow-tooltip>
          </el-table-column>
          <el-table-column align="center" prop="shopName" label="下单自提点" show-overflow-tooltip>
          </el-table-column>
          <el-table-column align="center" prop="birthdayTime" label="已出生时间">
          </el-table-column>
          <el-table-column align="center" prop="referValue" label="参考数值(mg/dl)">
          </el-table-column>
          <el-table-column align="center" prop="tbJaundiceValue" label="测量数值(mg/dl)">
          </el-table-column>
          <el-table-column align="center" prop="tbState" label="测量结果">
          </el-table-column>
        </el-table>
      </div>
      <pagination class="ui-papagination" @size-change="page.pagingSizeChange" @current-change="page.pagingCurrentChange" :total="page.total" :pageSizes="page.pageSizes" :pageSize="page.pageSize" :currentPage="page.currentPage"></pagination>
    </div>
  </div>
</template>
<script>
const files = require.context('/', false, /\.vue$/)
const suffixList = files.id
  .split(' ')[0]
  .split('/')
  .filter((a, b) => b > 2)
const fileName = 'jaundice'
const controller = 'jaundiceStatistics'
import { debounceUtils } from '@/utils/common.js'
import { mapGetters } from 'vuex'
import cal from '@/utils/calculation';
export default {
  name: `${suffixList.join('')}${fileName}`,
  data () {
    const _this = this
    return {
      pathCode: `${suffixList.join('')}${fileName}`,
      filePath: ['', ...suffixList, fileName].join('/'),
      fileName: fileName,
      detailName: `${fileName}Detail`,
      loading: true,
      tableHeight: null,
      page: {
        currentPage: 1, //当前页
        pageSize: 10, //每页记录数
        total: 10,
        pageSizes: [10, 20, 50, 100],
        pagingSizeChange (value) {
          _this.page.currentPage = 1
          _this.page.pageSize = value
          _this.getList()
        },
        pagingCurrentChange (value) {
          _this.page.currentPage = value
          _this.getList()
        }
      },
      tableList: [],
      jaundiceData: [
        [0, 0],
        [3, 0],
        [10, 1.5],
        [20, 3.3],
        [30, 4.9],
        [40, 6.1],
        [50, 7.1],
        [60, 7.9],
        [70, 8.5],
        [80, 9.0],
        [90, 9.4],
        [100, 9.6],
        [110, 9.8],
        [120, 10.0],
        [130, 9.9],
        [140, 9.7],
        [150, 9.4],
        [160, 9.1],
        [168, 8.8],
        [720, 8.8]
      ],
      shopList: [],
      seach: {
        userName: '',
        tbPhone: '',
        tbState: '',
        tbShopId: ''
      }
    }
  },
  computed: {
    ...mapGetters(['lastBreadCrumb', 'refreshPage'])
  },
  watch: {
    $route (to, from) {
      if (to.path === this.filePath && this.refreshPage) {
        this.getList()
        this.$store.dispatch('setRefreshPage', false)
      }
    }
  },
  methods: {
    getReferValue (row) {
      let birthday = row.birthday
      let createTime = row.createTime
      let time = Math.abs(new Date(createTime).getTime() - new Date(birthday).getTime())
      const day = Math.floor(time / 1000 / 60 / 60 / 24)
      const hour = Math.floor((time - day * 24 * 60 * 60 * 1000) / 1000 / 60 / 60) + 1
      time = 24 * day + hour
      time = time > 720 ? 720 : time
      const index = this.jaundiceData.findIndex(([x, y], index) => time <= x, 0)
      const [x1, y1] = this.jaundiceData[index - 1]
      const [x2, y2] = this.jaundiceData[index]
      const temp = cal.accMul(cal.accDiv(cal.accSub(y2, y1), cal.accSub(x2, x1)), cal.accSub(time, x2))
      row.referValue = Number(cal.accAdd(temp, y2).toFixed(2))
      row.birthdayTime = `${day}天${hour}小时`
      row.tbState = cal.accSub(row.referValue, row.tbJaundiceValue) >= 0 ? '正常' : '异常'
      return row
    },
    getShopList () {
      this.$http.get('/shopInfo/selectList', {})
        .then(res => {
          if (res.code === 1000) {
            this.shopList = res.data
          } else {
            this.$message.error(res.message)
          }
        })
    },
    updateFiled (row, filed) {
      this.$http.post(`/${controller}/save`, {
        tbId: row.tbId,
        [filed]: row[filed]
      })
        .then(res => { })
    },
    del (id) {
      this.msgboxMixin(() => {
        this.$http.post(`/${controller}/delete`, { tbId: id }).then((res) => {
          if (res.code === 1000) {
            this.getList()
          } else {
            this.$message.error(res.message)
          }
        })
      })
    },
    reset () {
      this.seach = {
        userName: '',
        tbPhone: '',
        tbState: '',
        tbShopId: ''
      }
    },
    getList: debounceUtils(function () {
      this.loading = true
      this.seach.page = this.page.currentPage
      this.seach.size = this.page.pageSize
      this.$http.get(`/${controller}/findListByCustomer`, this.seach).then((res) => {
        this.loading = false
        if (res.code === 1000) {
          this.tableList = res.data.list.map(i => {
            return this.getReferValue(i)
          })
          this.page.total = res.data.total
        } else {
          this.$message.error(res.message)
        }
      })
    }, 500)
  },
  destroyed () {
    this.destroyResizeListen(448)
  },
  created () {
    this.addResizeListen(448)
  },
  mounted () {
    if (this.$route.query.phone) {
      this.seach.tbPhone = this.$route.query.phone
    }
    this.getList()
    this.getShopList()
  },
  components: {
  }
}
</script>

<style lang="scss" scoped>
.ui-content {
  width: 100%;
  height: 100%;
  .ui-seachBox {
    margin: 0 24px 24px;
    width: calc(100% - 48px);
    height: 84px;
    background: #ffffff;
    border-radius: 2px;
    .row-bg {
      padding: 24px 24px 0;
      .ui-seachBox-label {
        display: inline-block;
        text-align: right;
        width: 100px;
        height: 22px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #000000;
        line-height: 32px;
        vertical-align: top;
      }
      .ui-seachBox-label2 {
        display: inline-block;
        text-align: right;
        height: 22px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #000000;
        line-height: 32px;
        vertical-align: top;
        margin-right: 10px;
      }
      .ui-seachBox-box-switch {
        height: 32px;
        line-height: 32px;
        vertical-align: top;
      }
      .ui-seachBox-Symbol {
        margin-left: 3px;
        margin-right: 5px;
      }
      .ui-seachBox-input {
        display: inline-block;
        width: calc(100% - 100px);
        height: 32px;
        background: #ffffff;
        border-radius: 2px;
        border: 1px solid rgba(0, 0, 0, 0.15);
        ::v-deep .el-icon-circle-close,
        ::v-deep .el-icon-arrow-down,
        ::v-deep .el-icon-arrow-up,
        ::v-deep .el-icon-date,
        ::v-deep .el-input__inner {
          vertical-align: top;
          height: 30px;
          line-height: 30px;
          border: none;
        }
      }
      .ui-seachBox-box-label {
        display: inline-block;
        width: calc(100% - 100px);
        height: 32px;
        line-height: 32px;
      }
    }
    .ui-seachBox-reset {
      margin: 0 0 0 8px;
      float: right;
      border-radius: 2px;
      padding: 9px 15px;
      &:focus {
        outline: none;
      }
    }
    .ui-seachBox-submit {
      padding: 9px 15px;
      margin: 0 24px 0 8px;
      float: right;
      border-radius: 2px;
      &:focus {
        outline: none;
      }
    }
  }
  .ui-tableBox {
    margin: 0 24px;
    width: calc(100% - 48px);
    background: #ffffff;
    border-radius: 2px;
    height: calc(100% - 132px);
    position: relative;
    .ui-tableBox-bar {
      position: relative;
      margin: 0 24px;
      height: 64px;
      .ui-tableBox-title {
        height: 24px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #000000;
        line-height: 24px;
        display: inline-block;
        margin-top: 20px;
      }
      .ui-tableBox-button {
        width: 108px;
        position: relative;
        float: right;
        top: 16px;
        margin-left: 24px;
        border-radius: 2px;
        border: 1px solid rgba(0, 0, 0, 0.15);
        &.export {
          padding: 8px 15px;
          width: auto;
        }
        ::v-deep .el-icon-arrow-up,
        ::v-deep .el-input__inner {
          height: 30px;
          line-height: 30px;
          border: none;
          &::-webkit-input-placeholder {
            color: #606266;
          }
          &::-moz-placeholder {
            color: #606266;
          }
          &::-ms-input-placeholder {
            color: #606266;
          }
        }
        &:focus {
          outline: none;
        }
      }
    }
    .ui-tableList {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #000000;
      margin: 8px 24px 0 24px;
      .ui-box-tableList-img {
        width: 80px;
        height: 80px;
        background: #d8d8d8;
        display: inline-block;
        vertical-align: top;
      }
      .ui-box-tableList-label {
        margin: 0 5px 10px;
      }
      .ui-box-tableList-editImg {
        width: 43px;
        cursor: pointer;
        height: 43px;
      }
      .ui-box-tableList-tempSaveImg {
        width: 41px;
        height: 41px;
        position: absolute;
        left: -2px;
        top: -3px;
      }
      ::v-deep .el-table__body-wrapper {
        height: auto !important;
      }
      .ui-tableList-button {
        padding: 9px 17px;
        outline: none;
      }
      .ui-tableList-link.is-underline:hover:after {
        border: none;
      }
    }
  }
}
</style>